<template>
  <div class="flex-row vptbox" :style="{ height: pageHeight }" style="flex-wrap:wrap">
    <div @click="gocase1" class="modeclass" style="margin-right:10%">
      <img src="@/assets/vpticon1.png" class="vpticon">
      <div class="vpttext flex-row">训练模式</div>
    </div>
    <div class="modeclass" @click="gocase2">
      <img src="@/assets/vpticon2.png" class="vpticon">
      <div class="vpttext flex-row">考试模式</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageHeight: '100px'
    }
  },
  mounted() {
    this.pageHeight = document.documentElement.clientHeight - 80 + "px";
  },
  methods: {
    gocase1() {
      this.$router.push({
        path: '/caselist'
      })
    },
    gocase2() {
      this.$router.push({
        path: '/spExam',
        query:{
          type:2
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.modeclass {
  width: 300px;
  max-width: 90%;
  height: 400px;
  background: #fff;
  border-radius: 10px;
  cursor:pointer;
}
.vptbox .modeclass:hover{
  box-shadow: 0 0 10px #ccc;
}
.vpticon {
  width: 90%;
  margin-left: 5%;
}
.vpttext{
  font-size:18px;
  font-weight: bold;
  margin-top:20px;
  color:#3d3d3d;
}
</style>